import React from "react";
import PropTypes from "prop-types";

import StandardContactCard from "./StandardContactCard";
import SecondaryContactCard from "./SecondaryContactCard";
import ComponentMissing from "../../Debug/ComponentMissing";

const ContactCardSwitcher = ({
  layout,
  header,
  headerType,
  headerDisplayStyle,
  subline,
  image,
  contactInfo,
  animation,
}) => {
  const properties = {
    header,
    headerType,
    headerDisplayStyle,
    subline,
    image,
    contactInfo,
    animation,
  };

  function switchContactCard() {
    switch (layout) {
      case "standard":
        return <StandardContactCard properties={properties} />;
      case "secondary":
        return <SecondaryContactCard properties={properties} />;
      default:
        return <ComponentMissing type="ContactCard" subType={layout} />;
    }
  }

  return switchContactCard();
};

ContactCardSwitcher.propTypes = {
  layout: PropTypes.string,
  header: PropTypes.string,
  headerType: PropTypes.string,
  headerDisplayStyle: PropTypes.string,
  subline: PropTypes.string,
  image: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.string]),
  contactInfo: PropTypes.instanceOf(Object),
  animation: PropTypes.instanceOf(Object),
};

export default ContactCardSwitcher;
